var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-map-wrap",staticStyle:{"height":"67%"}},[_c('div',{staticClass:"device-map"},[_c('vue-amap',{ref:"amap",attrs:{"d3-features":['bg', 'road', 'point']},on:{"complete":_vm.setMarkers}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }